import { render, staticRenderFns } from "./CrmDiscount.vue?vue&type=template&id=82b63a0c&scoped=true"
import script from "./CrmDiscount.vue?vue&type=script&lang=js"
export * from "./CrmDiscount.vue?vue&type=script&lang=js"
import style0 from "./CrmDiscount.vue?vue&type=style&index=0&id=82b63a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b63a0c",
  null
  
)

export default component.exports